// @flow
import type { ERROR_TYPE } from './common';

export type PHONE_CODE_REQUEST_STARTED_TYPE = {
  type: 'PHONE_CODE_REQUEST_STARTED',
  payload: {
    phone: string,
    role: string
  }
};
export const PHONE_CODE_REQUEST_STARTED = 'PHONE_CODE_REQUEST_STARTED';

export type PHONE_CODE_REQUEST_SUCCEED_TYPE = {
  type: 'PHONE_CODE_REQUEST_SUCCEED'
};
export const PHONE_CODE_REQUEST_SUCCEED = 'PHONE_CODE_REQUEST_SUCCEED';

export type PHONE_CODE_REQUEST_FAILED_TYPE = {
  type: 'PHONE_CODE_REQUEST_FAILED',
  payload: ERROR_TYPE
};
export const PHONE_CODE_REQUEST_FAILED = 'PHONE_CODE_REQUEST_FAILED';

export type PHONECODEREQUEST_ACTION_TYPE =
  | PHONE_CODE_REQUEST_STARTED_TYPE
  | PHONE_CODE_REQUEST_SUCCEED_TYPE
  | PHONE_CODE_REQUEST_FAILED_TYPE;



// WEBPACK FOOTER //
// ./src/scripts/types/phoneCodeRequest.js